import { NgModule } from '@angular/core';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [UserMenuComponent],
  imports: [MenuModule, ButtonModule, SharedModule],
  exports: [UserMenuComponent],
})
export class SettingsModule {}
